import { render, staticRenderFns } from "./example-my-point.vue?vue&type=template&id=27bc2446"
import script from "./example-my-point.vue?vue&type=script&lang=js"
export * from "./example-my-point.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports